import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { toZonedTime } from 'date-fns-tz';
import { isSameDay } from 'date-fns';

@Component({
  selector: 'lib-formly-date-picker',
  imports: [
    NzFormModule,
    ReactiveFormsModule,
    CommonModule,
    NzDatePickerModule,
    FormlyModule,
  ],
  templateUrl: './formly-date-picker.component.html',
  styleUrl: './formly-date-picker.component.scss',
})
export class FormlyDatePickerComponent extends FieldType<FieldTypeConfig> {
  get errorState() {
    return this.showError ? 'error' : '';
  }

  get currentDateTime() {
    return toZonedTime(new Date(), 'Asia/Tokyo');
  }
}
